import React, { Component } from 'react';

export default class Logo extends Component {
  render() {
    const color = this.props.black ? '#000' : '#fff';
    return (
      <svg className="logo-home" width={149} height={60}>
        <g fill="none" fillRule="evenodd">
          <path
            fill={color}
            d="M6.5 31.16L16.56 30v6.1L0 38V12.66l6.5-.75v19.25zM33.84 8.8l6.03-.7v15.67c0 5.52-4.52 10.52-10.12 11.16l-.58.07c-5.56.64-10.08-3.32-10.08-8.84V10.5l6.03-.7v14.23c0 2.87 1.45 5 4.05 4.7l.58-.07c2.42-.28 4.08-2.76 4.08-5.63V8.8zM56.8 6.12l6.5-.75v25.34l-6.5.75-7.52-12.72v13.59l-6.54.75V7.74l6.54-.75L56.8 19.7V6.12zM78.38 23a7.73 7.73 0 0 0 4.73-2.48l4.41 3.87a14.66 14.66 0 0 1-9.14 4.81c-7.12.82-12.9-4.25-12.9-11.3 0-7.1 5.78-13.5 12.9-14.32 3.58-.41 6.8.65 9.14 2.7l-4.4 4.89a6.16 6.16 0 0 0-4.74-1.4 7.67 7.67 0 0 0-6.65 7.4c0 3.62 3 6.25 6.65 5.83zM103.49.75L110 0v25.34l-6.5.75v-9.46l-7.3.84v9.46l-6.51.75V2.34l6.5-.75v9.43l7.3-.84V.75z"
          />
          <path
            fill="#12D2B4"
            d="M64 41.6l-9.51 1.1v3.73l7.62-.88v4.61l-7.62.87v8.34L49 60V38.72L64 37v4.6zm7-5.6v21.37L66 58V36.63l5-.63zm-2.53-1.02c-1.37.16-2.4-.83-2.47-2.18-.06-1.38 1.1-2.63 2.47-2.78a2.2 2.2 0 0 1 2.53 2.2c0 1.36-1.13 2.6-2.53 2.76zm17.15-.36L91 34v21.04l-5.38.62-6.21-10.56v11.27L74 57V35.97l5.4-.63 6.22 10.56V34.62zm13.8-1.34c3.68-.42 7.14-.67 10.07 1.57 3.58 2.78 4.55 7.95 2.32 12.43-3.56 7.16-11.3 6.98-17.81 7.72V33.9l5.42-.62zm7.43 10.74c.8-3.36-1.7-6.3-5-6l-2.85.33V49c3.3-.39 6.93-1.04 7.85-4.98zM130 46.69v4.63L115 53V31.65L129.72 30v4.62l-9.08 1.02v3.74l7.64-.86v4.62l-7.64.86v3.75L130 46.7zm15.4-6.12l3.6 8.49-5.43.62-3.35-7.49-3.15.36v7.87L132 51V30.16l9.8-1.12a5.74 5.74 0 0 1 6.6 5.74c0 2.26-1.2 4.4-3 5.79zm-2.4-5.6c0-1.16-.91-1.98-2.08-1.94V33l-4.92.54V38l4.92-.54a2.62 2.62 0 0 0 2.08-2.49z"
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Logo.jsx